/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    const {
      code,
      business_id: businessId,
      waba_id: wabaId,
      phone_number_id: phoneNumberId,
      external_tenant_id: externalTenantId,
      provisioning_id: provisioningId,
      onboarding_session_id: onboardingSessionId,
    } = params;

    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      code,
      business_id: businessId,
      waba_id: wabaId,
      phone_number_id: phoneNumberId,
      external_tenant_id: externalTenantId,
      provisioning_id: provisioningId,
      onboarding_session_id: onboardingSessionId,
    });
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }
}

export default new WhatsappChannel();
